module.exports = __webpack_public_path__ + "img/speed-data.6e57359.svg";